import Button from './Button.js';
import { Colors } from '../../consts/Colors.js';
export default class ButtonRounded extends Button {
    constructor(
        scene,
        x,
        y,
        w,
        h,
        text,
        text_color,
        box_color,
        hasAnStroke = false,
        stroke_color,
        hasAnIcon = false,
        icon = null,
        url,
    ) {
        let params = {
            width: w,
            height: h,
            text: text,
            text_color: text_color,
            box_color: box_color,
            hasAnStroke: hasAnStroke,
            stroke_color: stroke_color,
            hasAnIcon: hasAnIcon,
            icon: icon,
            Url: url,
        };

        if (hasAnStroke) {
            params.stroke_color = stroke_color;
        } else {
            params.stroke_color = 'transparent';
        }

        super(scene, x, y, params);

        this.defaultBoxColor = box_color;
        this.defaultTextColor = text_color;
    }

    addBody(params) {
        // Add the button body and text here
        // Ajout fond
        this.back = this.scene.add.rexRoundRectangle(
            0,
            0,
            params.width,
            params.height,
            params.height / 2,
            params.box_color, // Utilise la couleur du bouton
        );
        this.back.setOrigin(0.5);
        this.back.setFillStyle(params.box_color, 1);
        this.add(this.back);

        if (params.hasAnIcon) {
            // Cas normal
            this.icon = this.scene.add.image(params.width / 2 - 30, 0, params.icon).setOrigin(0.5);
            this.icon.setScale(0.3);
            this.add(this.icon);

            this.text = this.scene.add
                .rexTagText(
                    this.scene.game.data.langue === 'ara'
                        ? params.width / 2 - 50
                        : this.scene.game.data.langue === 'esp' ||
                            this.scene.game.data.langue === 'por'
                          ? -20
                          : 0,
                    0,
                    params.text,
                    {
                        fontSize: 24 * this.scene.game.data.scaleX + 'px',
                        fontFamily:
                            'DMSansBold, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
                        align: this.scene.game.data.langue === 'ara' ? 'right' : 'center',
                        resolution: 2,
                        color: params.text_color,
                        backgroundColor: 'transparent',
                        rtl: this.scene.game.data.langue === 'ara',
                        padding: { bottom: 10, top: 10 },
                        // letterSpacing: 0.5,
                    },
                )
                .setOrigin(
                    this.scene.game.data.langue === 'ara' ? 1 : 0.5,
                    this.scene.game.data.langue === 'ara' ? 0.5 : 0.5,
                );
            this.add(this.text);
        } else {
            const isAra = this.scene.game.data.langue === 'ara';

            this.text = this.scene.add.rexTagText(
                this.scene.game.data.langue === 'ara' ? 60 : 0,
                0,
                params.text,
                {
                    fontSize: 24 * this.scene.game.data.scaleX + 'px',
                    fontFamily:
                        'DMSansBold, "NotoSansJP", "NotoSansArabic", "NotoSansThai", sans-serif',
                    color: params.text_color,
                    align: this.scene.game.data.langue === 'ara' ? 'right' : 'center', // on garde center pour le layout
                    padding: { bottom: 10, top: 10 },
                    resolution: 2,
                    wordWrap: { width: params.width - 40, useAdvancedWrap: true }, // évite que ça sorte
                    rtl: isAra,
                    backgroundColor: 'transparent',
                },
            );

            // IMPORTANT: origin propre
            this.text.setOrigin(0.5, 0.5);

            this.add(this.text);
        }

        if (this.text.height > params.height) {
            this.back.height = this.text.height + 10;
        }

        // Ajout interaction
        this.setSize(this.back.width, this.back.height);

        this.setInteractive({ useHandCursor: true });
        this.on('pointerover', this.pointerOver, this);
        this.on('pointerout', this.pointerOut, this);
    }

    pointerOut() {
        this.back.setScale(1);
    }

    pointerOver() {
        this.back.setScale(1.05);
    }

    setLocked() {
        this.isLocked = true;
        this.setAlpha(0.6);
        this.disableInteractive();
        this.back.setFillStyle(Colors.Elmt.White);
        this.text.setColor(Colors.Text.BleuNovotel);
    }

    setUnlocked() {
        this.isLocked = false;
        this.setAlpha(1);
        this.setInteractive();
        this.back.setFillStyle(this.defaultBoxColor);
        this.text.setColor(this.defaultTextColor);
    }

    // -- Modif du text
    setText(txt) {
        this.text.setText(txt);
    }

    setTextColor(color) {
        this.text.color = color;
    }

    setTextFont(fontFamily) {
        this.text.fontFamily = fontFamily;
    }

    setTextSize(fontSize) {
        this.text.fontSize = fontSize;
    }
}
